<script>
export default {
  name: 'NotificationPopup',

  props: {
    notification: {
      type: Object,
      required: true,
      default: () => ({
        subject: '',
        message: '',
        technician: '',
      }),
    },

    duration: {
      type: Number,
      default: 10000,
    },

    autoClose: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visible: true,
      progressWidth: 100,
      timer: null,
      progressTimer: null,
      startTime: null,
      remainingTime: this.duration,
      isPaused: false,
      isTechnician: false
    }
  },

  mounted() {
    this.show()
    console.log(this.notification)
  },

  beforeDestroy() {
    this.clearTimers()
  },

  methods: {
    show() {
      this.isTechnician = Number(this.$store?.state?.users?.user?.position_id) === Number(process.env.VUE_APP_TECHNICIAN_POSITION_ID)
      this.visible = true
      if (this.autoClose) {
        this.startAutoClose()
      }
    },

    close() {
      this.visible = false
      this.clearTimers()
      this.$emit('close')
    },

    dismiss() {
      this.$emit('dismiss', this.notification)
      this.close()
    },

    viewDetails() {
      this.$emit('view-details', this.notification)
      this.close()
    },

    clearTimers() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      if (this.progressTimer) {
        clearInterval(this.progressTimer)
        this.progressTimer = null
      }
    },

    pauseAutoClose() {
      if (!this.autoClose || this.isPaused) return

      this.isPaused = true

      const elapsed = Date.now() - this.startTime
      this.remainingTime -= elapsed

      this.clearTimers()
    },

    resumeAutoClose() {
      if (!this.autoClose || !this.isPaused) return

      this.isPaused = false
      this.startAutoClose()
    },

    startAutoClose() {
      this.startTime = Date.now()
      const interval = 50
      const steps = this.remainingTime / interval
      const decrement = this.progressWidth / steps

      this.progressTimer = setInterval(() => {
        if (!this.isPaused) {
          this.progressWidth -= decrement
          if (this.progressWidth <= 0) {
            this.progressWidth = 0
          }
        }
      }, interval)

      this.timer = setTimeout(() => {
        this.close()
      }, this.remainingTime)
    },
  },
}
</script>

<template>
  <transition name="slide-fade">
    <b-card v-if="visible" no-body class="mc-notification-popup" @mouseenter="pauseAutoClose"
      @mouseleave="resumeAutoClose">
      <b-card-header class="mc-notification-popup__header">
        <div class="mc-notification-popup__icon">
          <i class="bx bx-bell"></i>
        </div>
        <h6 class="mc-notification-popup__title">New Notification</h6>
        <b-button variant="link" class="mc-notification-popup__close" @click="close">
          <i class="bx bx-x"></i>
        </b-button>
      </b-card-header>

      <b-card-body class="mc-notification-popup__body">
        <h6 class="mc-notification-popup__subject">{{ notification.subject }}</h6>
        <p class="mc-notification-popup__message">{{ notification.message }}</p>
        <p class="mc-notification-popup__technician">{{ isTechnician ? `Coordinator: ` : `Technician: ` }} {{
          notification.technician }}</p>
      </b-card-body>

      <b-card-footer class="mc-notification-popup__footer">
        <b-button variant="primary" v-if="!isTechnician && notification.wo_number" class="w-100" @click="viewDetails"> View Details </b-button>
        <b-button variant="outline-secondary" @click="dismiss"> Dismiss </b-button>
      </b-card-footer>

      <div class="mc-notification-popup__progress" :style="{ width: progressWidth + '%' }"></div>
    </b-card>
  </transition>
</template>
